import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";
import {
  countNumberUnit,
  migrateNumber,
  searchProductNumber,
} from "@/api/product-number";
import { Message } from "element-ui";

interface NumberModel {
  snId: string;
  snName: string;
  beforeCount: string;
  afterCount: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'numberMove',
  props: {
  productId: {
    type: String,
    required: true,
  },
  customerId: {
    type: String,
    required: true,
  },
  currentSn: {
    type: String,
    required: true,
  },
  currentSnId: {
    type: String,
    required: true,
  },
},
  emits: ["cancel"],
  setup(__props, { emit }) {

const props = __props;




let currentModel = ref<NumberModel>({} as NumberModel);
let targetModel = ref<NumberModel>({} as NumberModel);
let type = ref("");
let options = ref<{ id: string; sn: string; count: string }>(null);
let selectOptions = ref(null);
let disabled = ref(false);
onMounted(async () => {
  await searchProductNumber(
    {
      pageNumber: 1,
      pageSize: 9999999,
      customerId: props.customerId,
    },
    props.productId as string
  ).then((res: any) => {
    options.value = res.list;
  });
  await countNumberUnit(props.currentSnId as string).then((res) => {
    currentModel.value = {
      snId: props.currentSnId as string,
      snName: props.currentSn as string,
      beforeCount: res as any,
      afterCount: res as any,
    };
  });
});

watch(type, (value) => {
  if (value === "increase") {
    disabled.value = false;
  } else {
    changeSelectOptions();
  }
});

async function changeSelectOptions() {
  let select = selectOptions.value as any;
  if (!select) {
    disabled.value = false;
    return;
  }
  if (select.id === currentModel.value.snId && type.value === "merge") {
    disabled.value = true;
    return;
  } else {
    disabled.value = false;
  }

  let count1 = currentModel.value.beforeCount;
  currentModel.value.afterCount = "0" as string;
  await countNumberUnit(select.id as string).then((res) => {
    let after = Number(count1) + Number(res);
    targetModel.value = {
      snId: select.id as string,
      snName: select.sn as string,
      beforeCount: res as any,
      afterCount: after as any,
    };
  });
}

async function commit() {
  if (!type.value) {
    Message.error("请选择迁移类型");
    return;
  }
  if (
    (targetModel.value.snId as string) === (props.currentSnId as string) &&
    type.value === "merge"
  ) {
    Message.error("目标S/N不能与当前S/N相同");
    return;
  }
  await migrateNumber(type.value, {
    oldNumberIds: [currentModel.value.snId as string],
    newNumberId: targetModel.value.snId,
  }).then(() => {
    emit("cancel");
  });
}

function cancel() {
  emit("cancel");
}

return { __sfc: true,emit, props, currentModel, targetModel, type, options, selectOptions, disabled, changeSelectOptions, commit, cancel }
}

})